const validateSpecialCharacters = (_, value, callback) => {
    const specialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;
    if (specialCharacterRegex.test(value)) {
        callback('Special characters are not allowed.');
    } else {
        callback();
    }
};
export { validateSpecialCharacters };
